// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"794eb2aa","117":"88860fda","161":"a95abd06","209":"32193747","248":"ded7ea3d","478":"b7008c21","625":"e24e3863","745":"b5c83463","922":"a9748d02","964":"4ac2dac5"}[chunkId] + ".chunk.js";
};